
export interface IconStepperProps extends React.SVGProps<SVGSVGElement> {
    hasError?: boolean;
}

export const IconStepper = ({ hasError, ...rest }: IconStepperProps) => {
    return (
        <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <circle
                cx="4"
                cy="4"
                r="3"
                fill="#F7F8FA"
                stroke={hasError ? "#FA5252" : "#888E98"}
                strokeWidth="2"
            />
        </svg>
    );
};
